import React, { useState } from "react";
import ImageModal from "./cropper/ImageModal";


const ImageInput = ({onChange, defaultPic, aspect , className =""}) => {
    const [image, setImage] = useState("");
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [height, setHeight] = useState(null);
    const [width, setWidth] = useState(null);

    const onChangeHandler = base64 => {
        setImage("");
        onChange(base64);
    };

    const handleFile = e => {
        if (e.target.files.length > 0) {
            const file = e.target.files;
            var url = URL.createObjectURL(file[0]);
            var img = new Image();
            img.src = url;
            img.onload = function () {
                setWidth(this.width);
                setHeight(this.height);
            };
            const maxAllowedSize = 10 * 1024 * 1024;
            if (file[0].size > maxAllowedSize) {
                console.log("max image size");
            } else {
                setImage(file[0]);
                setModalIsOpen(true);
            }
            e.target.value = null;
        }
    };
    let inputElement;

    return (
        <div className={"h-100"}>
            <ImageModal
                aspect ={aspect}
                modalIsOpen={modalIsOpen}
                closeModal={() => {
                    setModalIsOpen(prevState => !prevState);
                }}
                image={image}
                onCropImage={croppedImg => onChangeHandler(croppedImg)}
                ratio={height / width <= 0.5 ? true : false}
            />
            <button type={"button"} className={`${className} btn bg-transparent w-100 h-100`} onClick={() => inputElement.click()}>
                {defaultPic && <img
                    src={defaultPic}
                    className={"default-company-logo w-100 mb-2"}
                    alt="تصویر پیش فرض"
                    onError={e => (e.target.src = defaultPic)}
                />}
                <p className={"btn btn-primary w-100 py-0 my-0"}>آپلود</p>
            </button>

            <input
                ref={input => (inputElement = input)}
                accept="image/*"
                type="file"
                style={{display: "none"}}
                onChange={handleFile}
            />
        </div>
    );
};

export default ImageInput;
